import PropTypes from 'prop-types'
import React from 'react'
import {connect} from 'react-redux'
import {useHistory} from 'react-router-dom'
import {createStructuredSelector} from 'reselect'

import * as addToLookActions from '../../actions/addToLook'
import * as cross from '../../store/cross'
import * as pdp from '../../store/productDetailPage'
import * as track from '../../track/track'
import * as URLS from '../../urls'

import ProductButton from './ProductButton'

import foldedJacketIcon from '../../../../svg/folded-up-jacket.svg'

const targetLinkName = 'Home Try-On Button'

function HtoButton({
  addProductToHtoLook,
  categoryIsHto,
  isHto,
  isRentSoldOutForEvent,
  productCollectionPageUrl,
  userIsParticipant,
}) {
  const history = useHistory()

  if (userIsParticipant) {
    return null
  }
  if (isHto && categoryIsHto && !isRentSoldOutForEvent) {
    return (
      <ProductButton
        title="Add to Home Try-On"
        subtitle="Preview for 3 days from the comfort of home"
        modifier="hto"
        onClick={() => {
          track.pdpClicked(targetLinkName)
          addProductToHtoLook()
        }}
      />
    )
  }
  if (categoryIsHto && !isRentSoldOutForEvent) {
    return (
      <ProductButton
        title="Browse Home Try-On"
        subtitle="Select a similar item to try at home."
        icon={foldedJacketIcon}
        modifier="hto"
        onClick={() => {
          const url = URLS.constructPcpHtoUrl(productCollectionPageUrl)
          track.pdpClicked(targetLinkName, url)
          history.push(url)
        }}
      />
    )
  }
  return (
    <ProductButton
      title="Home Try-On Not Available"
      icon={foldedJacketIcon}
      modifier="hto"
      disabled
    />
  )
}

HtoButton.propTypes = {
  addProductToHtoLook: PropTypes.func.isRequired,
  categoryIsHto: PropTypes.bool.isRequired,
  isHto: PropTypes.bool.isRequired,
  productCollectionPageUrl: PropTypes.string.isRequired,
  isRentSoldOutForEvent: PropTypes.bool.isRequired,
  userIsParticipant: PropTypes.bool.isRequired,
}

export default connect(
  createStructuredSelector({
    categoryIsHto: pdp.productCategoryIsHto,
    isHto: pdp.productIsHto,
    isRentSoldOutForEvent: cross.isRentSoldOutForEvent,
    productCollectionPageUrl: pdp.productCollectionPageUrl,
    userIsParticipant: cross.userIsParticipant,
  }),
  {
    addProductToHtoLook: addToLookActions.addProductToHtoLook,
  },
)(HtoButton)
